import { logAmplitudeEvent } from 'amplitude/amplitude'

import type { MountingCalcResult } from '../../types'

export const SNAPNRACK_ULTRA_RAIL_INTEGRATION = 'snapnrackUltraRail'

export function getSnapnrackAnalyticsContext(systemId?: string): {
  org_id?: string
  project_id?: string
  system_id?: string
} {
  const values = window.projectForm?.getState().values
  const org_id = values?.org_id != null && values.org_id !== '' ? String(values.org_id) : undefined
  const project_id = values?.id != null && values.id !== '' ? String(values.id) : undefined
  const resolvedSystemId = systemId ?? window.editor?.selectedSystem?.uuid ?? undefined

  return {
    ...(org_id ? { org_id } : {}),
    ...(project_id ? { project_id } : {}),
    ...(resolvedSystemId ? { system_id: resolvedSystemId } : {}),
  }
}

export function trackSnapnrackRackingError(
  errorType: string,
  error_msg: string,
  context?: Record<string, unknown>
): void {
  // Fire from BOM-generation paths only (see K2UK / Van Der Valk), not from afterCalculate sync hooks.
  const { systemId, ...rest } = context ?? {}
  logAmplitudeEvent('integrated_racking_dialog_error', {
    integration: SNAPNRACK_ULTRA_RAIL_INTEGRATION,
    errorType,
    error_msg,
    ...getSnapnrackAnalyticsContext(typeof systemId === 'string' ? systemId : undefined),
    ...rest,
  })
}

export function trackPZSEMaxSpanFetch(
  fetchSuccess: boolean,
  maxSpanInches: number | null,
  options?: { error_type?: string; systemId?: string }
): void {
  logAmplitudeEvent('pzse_max_span_fetched', {
    integration: SNAPNRACK_ULTRA_RAIL_INTEGRATION,
    fetch_success: fetchSuccess,
    max_span_inches: maxSpanInches,
    ...(options?.error_type ? { error_type: options.error_type } : {}),
    ...getSnapnrackAnalyticsContext(options?.systemId),
  })
}

export type SnapnrackBomAnalyticsOptions = {
  railRun?: string
  railType?: string
  mountingType?: string
  attachment?: string
  attachmentSpacingInches?: string | number
  universalSkirtRail?: string
  cableManagers?: string
}

export type SnapnrackBomAmplitudeContext = {
  result: MountingCalcResult
  systemId?: string
  panelCount: number
  orientation: string
  roofType: string | null | undefined
  options: SnapnrackBomAnalyticsOptions
  pzseMaxSpanInches: number | null
  pzseCacheSuccess: boolean | null
  mlpeCount: number
}

export function trackSnapnrackBomSuccess(context: SnapnrackBomAmplitudeContext): void {
  const {
    result,
    systemId,
    panelCount,
    orientation,
    roofType,
    options,
    pzseMaxSpanInches,
    pzseCacheSuccess,
    mlpeCount,
  } = context

  logAmplitudeEvent('selected_native_mounting_system', {
    integration: SNAPNRACK_ULTRA_RAIL_INTEGRATION,
    systemId,
    itemCount: result.items.length,
    panelCount,
    orientation,
    roofType: roofType ?? undefined,
    railRun: options.railRun,
    railType: options.railType,
    mountingType: options.mountingType,
    attachment: options.attachment,
    attachmentSpacingInches: options.attachmentSpacingInches,
    universalSkirtRail: options.universalSkirtRail,
    cableManagers: options.cableManagers,
    hasMlpe: mlpeCount > 0,
    pzseMaxSpanInches,
    pzseCacheSuccess,
    ...getSnapnrackAnalyticsContext(systemId),
  })
}
